import Vue from 'vue';
import filters from './filters';

const loadFilter = (filter) => {
  const [filterName, filterFunction] = filter;
  Vue.filter(filterName, filterFunction);
};

Object.entries(filters).forEach(loadFilter);
